export default __webpack_public_path__ + "static/media/scholarship-community.37726cf4.webp";